import React, { useContext, useEffect, useState } from "react";
import Advertencia from "../../../../../assets/icons/advertenciaTransferencia.svg";
import { useSelector } from "react-redux";
import { selectResumenCompraPrecioTotal, selectResumenCompraProductosRequest } from "../../../../../reducers/carrito/carritoSelector";
import { UserContext } from "../../../../services/user";
import { CarritoContext } from "./ProcesoCompraLayout";
import { postComprasCheckoutSession } from "../../../../services/Api/MarketPlace/Compras";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { getStripePromise } from "../../../../utils/stripe";

const TransferenciaPago = ({datosEnvio}) => {

  const { informacionMetodoPago, setInformacionMetodoPago } = useContext(CarritoContext);
  const [clientSecret, setClientSecret] = useState("");
  const precioTotal = useSelector(selectResumenCompraPrecioTotal);
  const resumenCompra = useSelector(selectResumenCompraProductosRequest);
  const { user } = useContext(UserContext);

  useEffect(() => {
    let body = {
      usuario: {
        _id: user._id,
      },
      plantel: {
        _id: user.escuela.campus._id,
      },
      datosEnvio: {
        _id: datosEnvio._id,
      },
      factura: informacionMetodoPago.factura === "true",
      subTotal: precioTotal,
      total: precioTotal,
      carrito: resumenCompra,
      metodoDePago: "customer_balance",
    };

    postComprasCheckoutSession(body).then((response) => setClientSecret(response.clientSecret));
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <div id="checkout">
        {clientSecret && (
          <EmbeddedCheckoutProvider stripe={getStripePromise()} options={{ clientSecret }}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </div>
  );
};

export default TransferenciaPago;
